import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";
import {ImageCarouselComponent} from "../../../../app/shared/Componenti/ImageCarousel/ImageCarouselComponent";
import {ApiPathsService} from "../../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicEditComponent} from "../../../../app/shared/dynamic-edit/dynamic-edit.component";
import {forkJoin} from "rxjs";
import {GetImponibile, idsToBase64, PrezzoIvato} from "./../ProductUtility";
import {map} from "rxjs/operators";
import {DynamicListComponent} from "../../../../app/shared/dynamic-list/dynamic-list.component";

function CatalogoModerazione() {
  var OBJ: OggettoConfig = {
    Id: "catalogo_moderazione",
    RestRoute: '/prodotti',
    listRoute:'list',
    ListResponseHasData:true,
    listTitle: 'Catalogo e moderazione',

    ListDefaultFilter:{
      standby: null,
      page: 0,
      size:50,
      revisione:null,
      all:true
    },
    Filters:[
      CampoAggiuntivo.SingleDropdown(
        "",
        "standby",
        [
          { id: null, label: "Tutti" },
          { id: false, label: "Pubblicato" },
          { id: true, label: "In bozza" }
        ],
        "label",
        {
          placeholder: "Stato prodotto venditore"
        }
      ),
      CampoAggiuntivo.SingleDropdown(
        "",
        "revisione",
        [
          { id: null, label: "Tutti" },
          { id: false, label: "Pubblicati" },
          { id: true, label: "Oscurato" }
        ],
        "label",
        {
          placeholder: "Stato pubblicazione"
        }
      ),
      CampoAggiuntivo.TextField("", "pdv", 'col-lg-3', { placeholder:"Cerca prodotto..."}),
      CampoAggiuntivo.TextField(" ", "negozio", 'col-lg-3',{ placeholder: "Cerca venditore..."}),

    ],
    PrintHeaders:[],
    /*asyncFullResponseMap: async (response, component, callback)=>{
      const imgs = await idsToBase64(
        response.data.map(p=>p.id_immagine),
        component.api.getBaseAPI()
      );

      response.data = response.data.map((x,i)=>({
        ...x,
        Immagine: imgs[i]
      }));

      callback(response);
    },*/
    asyncFullResponseMap: async (response, component, callback) => {
      const products = response?.data ?? [];

      response.data = products.map(product => ({
        ...product,
        Immagine: ''
      }));

      callback(response);

      // try {
      //   const imgs = await idsToBase64(
      //     products.map(product => product.id_immagine),
      //     component.api.getBaseAPI()
      //   );
      //
      //   response.data = products.map((product, index) => ({
      //     ...product,
      //     Immagine: imgs[index] ?? ''
      //   }));
      //
      //   callback(response);
      // } catch (error) {
      //   console.error('Errore nel caricamento delle immagini:', error);
      // }
    },
    Headers: [
      /*CampoAggiuntivo.Html("Prodotto", (x)=>`<div class="pcell"><div class="pt"><img class="d-gal-img" src="${x.Immagine}" style="max-width: 50px; max-height: 50px; object-fit: cover"></div><span class="plink">${x.prodotto}</span></div>`),*/
      CampoAggiuntivo.Html(
        "Prodotto",
        (x,y) => `
    <div class="pcell">
      <div class="pt">
        ${x.id_immagine
          ? `<img class="d-gal-img"
                  src= "${y?.apiPaths?.getBaseAPI()}/file/image/${x.id_immagine}"
                  style="max-width:50px;max-height:50px;object-fit:cover">`
          : ''
        }
      </div>
      <span class="plink">${x.prodotto ?? ''}</span>
    </div>
  `
      ),
      CampoAggiuntivo.Html("Venditore", (x)=>`${x.esclusivaObject?.soprannome ?? ''}`),
      CampoAggiuntivo.Html("Categoria", (x)=>`${x.categorie?.map(cat=>cat.categoria).join(' / ')}`),
      CampoAggiuntivo.Html("Prezzo", (x)=> `<span class="font-weight-bold color-teal">${x.prezzi?.filter(y=>y.umlabel != 'pz')?.map(y=>"€"+PrezzoIvato(parseFloat(y.prezzo?.toString()),22).toDecimals(2)).join(', ')}</span>`),
      //CampoAggiuntivo.Html("Promo €", (x) => `<span class="font-weight-bold prezzo-nowrap">${x.promozione?.map(promo => `€${promo.sconto?.find(sc => true)?.prezzo?.toDecimals(2)}`).join(', ')}</span>`),
      CampoAggiuntivo.Html(
        "Promo €",
        x => `
    <span class="font-weight-bold prezzo-nowrap">
      ${
          x.promozione
            ?.map(promo => {
              const prezzo = promo.sconto?.[0]?.prezzo;
              return prezzo != null ? `€${Number(prezzo).toFixed(2)}` : '';
            })
            .filter(Boolean)
            .join(', ') ?? ''
        }
    </span>
  `
      ),
      CampoAggiuntivo.Html("Stato", (x)=>`<span class="bdg ${x.standby?'y' :'g'}">${x.standby? 'In bozza' : 'Pubblicato'}</span>`),
      CampoAggiuntivo.Html("Caricato", (x)=> `<span class="font-weight-bold">${x.data_creazione}</span>`),
      CampoAggiuntivo.Html("Pubblicazione", (x)=> `<span class="bdg ${x.revisione?'r' :'g'}">${x.revisione? 'Oscurato' : 'Pubblicato'}</span>`),
    ],
    AzioniLista: [
      ActionButton.FuncButton("view", (prodotto,api,end,toastr,component: DynamicCrudService)=>{
        const url = component.router.serializeUrl(
          component.router.createUrlTree([
            'marketplace/shared/dynamicedit/catalogo/', prodotto?.id
          ])
        );
        window.open(url, '_blank');
      }, {
        class: 'btn btn-o',
        iconLabel: 'Vedi',
        labelClass: 'text-primary',
      }),
      ActionButton.FuncButton("edit", (prodotto,api,end,toastr,component: DynamicCrudService)=>{
        const url = component.router.serializeUrl(
          component.router.createUrlTree([
            'marketplace/shared/dynamicedit/prodotto/', prodotto?.id
          ])
        );

        window.open(url, '_blank');

        //component.router.navigate(['marketplace/shared/dynamicedit/prodotto/', prodotto?.id])
        //window.location.href = `/marketplace/`;
      }, {
        class: 'btn btn-o',
        labelClass: 'text-primary',
        iconLabel: 'Modifica',
      }),
      ActionButton.FuncButton("oscura", (prodotto, api,onEnd)=>{
          if(!confirm("Il prodotto non è conforme alle policy del marketplace. Oscureremo il prodotto per metterlo in revisione."))return;
        api.ClassicPost("/prodotti/get", { id: prodotto.id }).subscribe((res: any) => {

          const prodottoCompleto = res?.data ?? res;

          const payload = {
            ...prodottoCompleto,
            revisione: true,
            categorie: (prodottoCompleto.categorie || []).map(c => c.id ?? c),
            colore: (prodottoCompleto.colore || prodottoCompleto.coloreObject || []).map(c => c.id ?? c),
            idMarca: prodottoCompleto.idMarca ?? prodottoCompleto.marcaObject?.id,
            stagione: prodottoCompleto.stagione ?? prodottoCompleto.stagioneObject?.id,
            prezzi: (prodottoCompleto.prezzi || []).map(p => ({
              prezzo: parseFloat(p.prezzo?.toString() ?? '0'),
              iva: p.iva ?? 22,
              um: p.um
            })),
            taglie: prodottoCompleto.taglie || [],
            promozione: prodottoCompleto.promozione || []
          };

          api.ClassicPost("/prodotti/update", payload).subscribe(() => {
            api.toastService.success(
              "Prodotto messo in revisione",
              "Prodotto oscurato",
              {timeOut:10000, extendedTimeOut:3000, toastClass:'marketplace-success-toast'}
            );

            if (onEnd) {
              onEnd();
            }
          });

        });

      }, {
        class: 'btn btn-o moderation-red',
        iconLabel: 'Oscura',
        labelClass: 'text-danger',
        noGet: true,
        hideif: { func: (x) => x.revisione === false }
      }),
      ActionButton.FuncButton("riabilita", (prodotto, api, onEnd) => {

        if (!confirm("Vuoi riabilitare questo prodotto e renderlo nuovamente valido?")) {
          return;
        }

        api.ClassicPost("/prodotti/get", { id: prodotto.id }).subscribe((res: any) => {

          const prodottoCompleto = res?.data ?? res;

          const payload = {
            ...prodottoCompleto,
            revisione: false,
            categorie: (prodottoCompleto.categorie || []).map(c => c.id ?? c),
            colore: (prodottoCompleto.colore || prodottoCompleto.coloreObject || []).map(c => c.id ?? c),
            idMarca: prodottoCompleto.idMarca ?? prodottoCompleto.marcaObject?.id,
            stagione: prodottoCompleto.stagione ?? prodottoCompleto.stagioneObject?.id,
            prezzi: (prodottoCompleto.prezzi || []).map(p => ({
              prezzo: parseFloat(p.prezzo?.toString() ?? '0'),
              iva: p.iva ?? 22,
              um: p.um
            })),
            taglie: prodottoCompleto.taglie || [],
            promozione: prodottoCompleto.promozione || []
          };
prodotto.revisione = false;
          api.ClassicPost("/prodotti/update", payload).subscribe(() => {
            api.toastService.success(
              "Prodotto riabilitato con successo",
              "Prodotto riabilitato",
              {timeOut:10000, extendedTimeOut:3000, toastClass:'marketplace-success-toast'}
            );

            if (onEnd) {
              onEnd();
            }
          });

        });

      }, {
        class: 'btn btn-o moderation-red',
        iconLabel: 'Riabilita',
        labelClass: 'text-success',
        noGet: true,
        hideif: { func: (x) => x.revisione !== false }
      })
    ],
    MenuItems:[
      {
        path: 'shared/dynamiclist/catalogo_moderazione',
        title: "Catalogo e moderazione",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
        notruoliOperativi: ['C']
      }
    ]
  }
  return OBJ;
}


export var CatalogoModerazioneEnv = () => {
  var env: any = {
    Modules: {
      "CatalogoModerazione": true
    },
    Cruds: [CatalogoModerazione()],
    Menu: [...CatalogoModerazione().MenuItems]
  }
  return env;

}
